import * as z from 'zod'

export const putSourceSchema = z.object({
    convertibleId: z.string().nullish(),
    internalComment: z.string().nullish(),
    issueId: z.string().nullish(),
    prId: z.string().nullish(),
    publishedDate: z.iso.datetime().nullish(),
    sourceType: z.string(),
    sourceUrl: z.string().nullish(),
    title: z.string().nullish(),
    warrantId: z.string().nullish(),
})
